/**
 * ReMind mark: two banks (clinic and home) joined by an arched bridge.
 * The arch is drawn in the honey --bridge token so the mark carries the
 * same colour that marks every therapist <-> patient touchpoint in the app.
 */
export default function BridgeMark({ size = 32, className = '' }: { size?: number; className?: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      className={className}
      aria-hidden="true"
    >
      <rect width="32" height="32" rx="10" fill="hsl(var(--primary))" />
      <path
        d="M6 21 Q16 7 26 21"
        fill="none"
        stroke="hsl(var(--bridge))"
        strokeWidth="3"
        strokeLinecap="round"
      />
      {[10, 13.5, 16, 18.5, 22].map((x) => (
        <line
          key={x}
          x1={x}
          x2={x}
          y1={x === 16 ? 14.2 : x < 16 ? 21 - (x - 6) * 0.9 : 21 - (26 - x) * 0.9}
          y2="21"
          stroke="hsl(var(--bridge))"
          strokeWidth="1.4"
          strokeLinecap="round"
          opacity="0.75"
        />
      ))}
      <circle cx="6" cy="22" r="2.6" fill="hsl(var(--primary-foreground))" />
      <circle cx="26" cy="22" r="2.6" fill="hsl(var(--primary-foreground))" />
    </svg>
  );
}
